import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

/**
 * Reusable form section with step number and colored left border
 * Used in: PayrollTab, WidgetCustomization, multi-step forms
 */
const FormSection = ({ 
  stepNumber, 
  title, 
  description,
  children,
  color = '#3B82F6', // blue
  expanded = true,
  onToggle,
  collapsible = false
}) => {
  const borderColor = `border-l-4`;
  
  return (
    <Card className={borderColor} style={{ borderLeftColor: color }}>
      <CardHeader 
        className={collapsible ? 'cursor-pointer' : ''}
        onClick={collapsible ? onToggle : undefined}
      >
        <div className={`flex items-start gap-4`}>
          {stepNumber && (
            <div 
              className="flex items-center justify-center w-10 h-10 rounded-full font-bold text-lg flex-shrink-0"
              style={{ 
                backgroundColor: `${color}20`,
                color: color 
              }}
            >
              {stepNumber}
            </div>
          )}
          <div className="flex-1">
            <CardTitle className="text-xl font-semibold">{title}</CardTitle>
            {description && (
              <p className="text-base text-gray-600 mt-1">{description}</p>
            )}
          </div>
          {collapsible && (
            <div className="text-gray-400">
              {expanded ? '▼' : '▶'}
            </div>
          )}
        </div>
      </CardHeader>
      {(!collapsible || expanded) && children && (
        <CardContent className="space-y-4">
          {children}
        </CardContent>
      )}
    </Card>
  );
};

export default FormSection;
